export default "__VITE_ASSET__BmZSREFl__"